module.exports = __webpack_public_path__ + "assets/img/f4f97dc1facc7664604884b82083c54c.svg";